let _nextId = 1;
function generateId() { return 'route_' + (_nextId++); }

export class TradeRoute {
  constructor(config) {
    this.id                     = config.id || generateId();
    const m = this.id.match(/^route_(\d+)$/);
    if (m) _nextId = Math.max(_nextId, parseInt(m[1], 10) + 1);

    this.name                   = config.name || 'Unnamed Route';
    this.shipId                 = config.shipId || null;
    this.managerId              = config.managerId || null;
    this.enabled                = config.enabled !== undefined ? config.enabled : false;
    this.mode                   = config.mode || 'sequential';  // 'sequential' | 'opportunistic'
    this.interestList           = config.interestList || [];     // ordered cargo type IDs
    this.stops                  = config.stops || [];   // [{ portId, actions }]
    this.currentStopIndex       = config.currentStopIndex || 0;
    this.consecutiveFailedLoops = config.consecutiveFailedLoops || 0;
    this.stats                  = config.stats || {
      completedLoops: 0,
      totalRevenue:   0,
      totalExpenses:  0
    };
  }

  getCurrentStop() {
    if (this.stops.length === 0) return null;
    return this.stops[this.currentStopIndex % this.stops.length];
  }

  getNextStop() {
    if (this.stops.length === 0) return null;
    return this.stops[(this.currentStopIndex + 1) % this.stops.length];
  }

  advanceStop() {
    if (this.stops.length === 0) return false;
    this.currentStopIndex = (this.currentStopIndex + 1) % this.stops.length;
    return this.currentStopIndex === 0; // true = loop completed
  }

  serialize() {
    return {
      id:                     this.id,
      name:                   this.name,
      shipId:                 this.shipId,
      managerId:              this.managerId,
      enabled:                this.enabled,
      mode:                   this.mode,
      interestList:           this.interestList,
      stops:                  this.stops,
      currentStopIndex:       this.currentStopIndex,
      consecutiveFailedLoops: this.consecutiveFailedLoops,
      stats:                  { ...this.stats }
    };
  }

  static deserialize(data) {
    return new TradeRoute({
      ...data,
      stats: data.stats ? { ...data.stats } : undefined
    });
  }
}
